import { Component } from 'react'
import { isJsonEqual } from 'iotera-base/json'

export class IoteraClass extends Component {
  constructor(props) {
    super(props)
  }

  shouldComponentUpdate(nextProps, nextState) {
    let currState = this.state
    let currProps = this.props

    let sameState = isJsonEqual(currState, nextState);
    let sameProps = isJsonEqual(currProps, nextProps);

    return !sameState || !sameProps;
  }

}

export default IoteraClass
